import React, { memo } from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import LogoMark from 'images/cg_icon_rgb_small.svg'
import LogoWordmark from 'images/cgtrader_RGB.svg'

function Logo({ url, locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <a
      className="unified-nav__logo"
      data-track-text=""
      data-track-label="Homepage"
      href={url}
    >
      {/* CSS pins the height to 24px with width: auto, so width/height only supply the
          aspect ratio reserved before the SVG loads. Each must match its own art (the
          SVGs' intrinsic sizes) or the logo resizes on load and shifts the bar. */}
      <picture>
        <source media="(min-width: 460px)" srcSet={LogoWordmark} width="190" height="50" />
        <img
          className="unified-nav__logo-img"
          src={LogoMark}
          alt={t('navigation.aria.logo')}
          width="40"
          height="40"
        />
      </picture>
    </a>
  )
}

Logo.propTypes = {
  url: string.isRequired,
  locale: string,
}

export default memo(Logo)
